import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/grupopontoacesso",

        async alterPosition({ id, dest }) {
            const url = this.userUrl({
                path: `/${id}/position/${dest}`
            });

            return Vue.http.put(url);
        },

        async create({ nome, parentId, localId } = {}) {
            const url = this.userUrl({
                path: "/"
            });

            const newAccessPointGroup = await Vue.http.post(url, {
                nome,
                parentId,
                localId
            });

            return newAccessPointGroup;
        },

        async update({ id, nome, localId }) {
            const url = this.userUrl({
                path: `/${id}`
            });

            const updateLocalGroup = await Vue.http.put(url, {
                id,
                nome,
                localId
            });

            return updateLocalGroup;
        },

        async get({ id }) {
            const url = this.userUrl({
                path: `/${id}`
            });

            return Vue.http.get(url);
        },

        async delete({ id }) {
            const url = this.userUrl({
                path: `/${id}`
            });

            return Vue.http.delete(url);
        }
    },
    base
);
